import React from 'react';
import { cn } from 'utils';

export function VideoFrame(
  props: React.PropsWithChildren<{
    className?: string;
    onClickVideo?: () => void;
  }>,
): React.ReactElement {
  const { children, className, onClickVideo } = props;
  const classNames = cn(
    'odin-bg-odin-black',
    'odin-flex',
    'odin-items-center',
    'odin-justify-center',
    'odin-min-h-[132px]',
    'odin-overflow-hidden',
    'odin-relative',
    'odin-rounded-md',
    'odin-w-full',
    'odin-h-full',
    className,
  );
  if (onClickVideo) {
    return (
      <button type="button" className={classNames} onClick={onClickVideo}>
        {children}
      </button>
    );
  }
  return <div className={classNames}>{children}</div>;
}
